import React from 'react'
import "./navbar.css"
import { useNavigate } from 'react-router-dom'


const Navbar = () => {

  const navigate= useNavigate();

  const handleSearch =() =>{
    navigate("/")
  }
  
  const handleLogin =() =>{
    navigate("/Login")
   }

   const handleRegistration=() =>{
    navigate("/Registration")
   }

  return (
    <div className="navbar">
      <div className="navContainer">
        <span className="logo">Easybooking</span>
        <div className="navItems">
        <button className="navButton" onClick={handleSearch}>Home</button>
        
          <button className="navButton" onClick={handleRegistration} >Register</button>
          <button className="navButton" onClick={handleLogin}>Login</button>
          
        </div>
        </div>
    </div>
  )
}

export default Navbar
